import { ReactNode } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

interface SideBarComponentProps {
  OffcanvasClass?: string;
  show: boolean;
  handleClose: () => void;
  placement?: "start" | "end" | "top" | "bottom";
  title?: string;
  titleClass?: string;
  isCloseButton?: boolean;
  children?: ReactNode;
}

const SideBarComponent: React.FC<SideBarComponentProps> = ({
  OffcanvasClass = "offCanvas-wrapper",
  show,
  handleClose,
  placement = "start",
  title,
  titleClass = "",
  isCloseButton = true,
  children,
}) => {
  return (
    <Offcanvas
      className={OffcanvasClass}
      show={show}
      onHide={handleClose}
      placement={placement}
    >
      {title && (
        <Offcanvas.Header closeButton={isCloseButton}>
          <Offcanvas.Title className={titleClass}>{title}</Offcanvas.Title>
        </Offcanvas.Header>
      )}
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default SideBarComponent;
